var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.663 9.587.624-.257a.328.328 0 0 1 .426.172 6.23 6.23 0 0 1-8.22 8.2l-1.188 2.349a8.856 8.856 0 0 0 11.662-11.92.325.325 0 0 1 .059-.37.328.328 0 0 1 .109-.076l.514-.216-3.488-1.6-.498 3.718Zm-2.155-3.29 1.187-2.348a8.857 8.857 0 0 0-11.662 11.92.326.326 0 0 1-.168.446l-.514.216 3.488 1.6.498-3.718-.624.257a.328.328 0 0 1-.426-.172 6.23 6.23 0 0 1 8.22-8.2Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.1da046a2.svg";
export { ForwardRef as ReactComponent };